import React, { useState, useEffect } from "react";
import { styled } from "@mui/system";
import {
  TablePagination,
  tablePaginationClasses as classes,
} from "@mui/base/TablePagination";
import API_URL from "../common/Apiurl";
import { Link } from "react-router-dom";
import "./common.css";
import {
  AiTwotoneDelete,
  AiTwotoneEdit,
  AiTwotoneEye,
} from "react-icons/ai";
import SearchBar from "material-ui-search-bar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessMessage from "../common/Message";
import ExportExcel from "../excelsheet/Excelexport";

function Provider() {
  const apiUrl = API_URL;
  const [page, setPage] = React.useState(0);
  const [alldata, setAlldata] = useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [items, setItems] = useState([]);
  const [searched, setSearched] = useState("");
  const [open, setOpen] = React.useState(false);
  const [deleteconfirm, setDeleteconfirm] = useState([]);
  const [messagetext, setMessagetext] = useState("");
  const [successMessages, setSuccessMessages] = useState([]);
  const [industryValue, setIndustryValue] = useState([]);
  const [categoryValue, setCategoryValue] = useState([]);
  const [subcategoryValue, setSubcategoryValue] = useState([]);
  const getData = localStorage.getItem("user-info");
  const accessbility = JSON.parse(getData).data.accessbility;
  const handleOpen = (e, id, msgtext) => {
    setOpen(true);
    var setmsg = "";
    if (msgtext === "0") {
      setmsg = "Unblock";
    } else if (msgtext === 1) {
      setmsg = "block";
    } else if (msgtext === 2) {
      setmsg = "delete";
    }
    setMessagetext(setmsg);
    var dataArray = [id, setmsg];
    setDeleteconfirm(dataArray);
    console.log(dataArray);
  };

  const handleClose = () => setOpen(false);
  const getComments = async () => {
    try {
      const res = await fetch(`${apiUrl}/admin/tradesmanlist`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await res.json();
      setItems(data.data);
      setAlldata(data.data);
      setIndustryValue(data.industrylist);
      setCategoryValue(data.categorylist);
      setSubcategoryValue(data.subcategorylist);
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.error("Error ", error);
    }
  };
  const getindustryValue = async () => {
    try {
      const res = await fetch(`${apiUrl}/admin/tradesmanlist`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const data = await res.json();
      if (data.status !== 200) {
        throw new Error("Data not found");
      }
      // setCsvitems(data.csvdata);
      // setItems(data.data);
      // setAlldata(data.data);
      setIndustryValue(data.industrylist);
      setCategoryValue(data.categorylist);
      setSubcategoryValue(data.subcategorylist);

    } catch (error) {
      console.error("Error ", error);
    }
  };
  useEffect(() => {
    if (
      localStorage.getItem("industryFilterIndustry_provider") !== null &&
      localStorage.getItem("industryFilterIndustry_provider") !== "" &&
      localStorage.getItem("categoryFilterIndustry_provider") !== null &&
      localStorage.getItem("categoryFilterIndustry_provider") !== "" &&
      localStorage.getItem("subCategoryFilterIndustry_provider") !== null &&
      localStorage.getItem("subCategoryFilterIndustry_provider") !== ""
    ) {
      
      getindustryValue()
      
      getindustry(localStorage.getItem("industryFilterIndustry_provider"));
      
      getcategory(localStorage.getItem("subCategoryFilterIndustry_provider"));
      
      getsubcategory(localStorage.getItem("subCategoryFilterIndustry_provider"));
    
    } else if (
      localStorage.getItem("industryFilterIndustry_provider") !== null &&
      localStorage.getItem("industryFilterIndustry_provider") !== "" &&
      localStorage.getItem("categoryFilterIndustry_provider") !== null &&
      localStorage.getItem("categoryFilterIndustry_provider") !== "" &&
      localStorage.getItem("subCategoryFilterIndustry_provider") === null &&
      localStorage.getItem("subCategoryFilterIndustry_provider") === ""
    ) {
      getindustryValue()

      getindustry(localStorage.getItem("industryFilterIndustry_provider"));
      
      getcategory(localStorage.getItem("subCategoryFilterIndustry_provider"));
    
    } else if (
      localStorage.getItem("industryFilterIndustry_provider") !== null &&
      localStorage.getItem("industryFilterIndustry_provider") !== "" &&
      localStorage.getItem("categoryFilterIndustry_provider") === null &&
      localStorage.getItem("categoryFilterIndustry_provider") === "" &&
      localStorage.getItem("subCategoryFilterIndustry_provider") === null &&
      localStorage.getItem("subCategoryFilterIndustry_provider") === ""
    ) {
      getindustryValue()

      getindustry(localStorage.getItem("industryFilterIndustry_provider"));
      
    } else {
      getComments();
    }
    // getComments();
  }, []);
  // Avoid a layout jump when reaching the last page with empty rows.
  var rows = "";
  if (items) {
    var rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
  }
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // const requestSearch = (searchedVal) => {
  //   const filteredRows = rows.filter((row) => {
  //     return row.name.toLowerCase().includes(searchedVal.toLowerCase());
  //   });
  //   setItems(filteredRows);
  // };
  // filtered
  const requestSearch = (searchedVal) => {
    var rows = alldata;
    const filteredRows = rows.filter((row) => {
      // return row.name.toLowerCase().includes(searchedVal.toLowerCase());
      const restult1 = row.name
        .toLowerCase()
        .includes(searchedVal.toLowerCase());
      if (!restult1) {
        return row.lastname.toLowerCase().includes(searchedVal.toLowerCase());
      } else {
        return restult1;
      }
    });
    if (filteredRows.length === 0) {
      const filteredRowstwo = rows.filter((row) => {
        return row.home_address
          .toLowerCase()
          .includes(searchedVal.toLowerCase());
      });
      if (filteredRowstwo.length === 0) {
        const filteredRowsthree = rows.filter((row) => {
          return row.office_location
            .toLowerCase()
            .includes(searchedVal.toLowerCase());
        });
        setItems(filteredRowsthree);
      } else {
        setItems(filteredRowstwo);
      }
    } else {
      setItems(filteredRows);
    }
  };
  // filtered
  // var rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
  if (items) {
    var rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
  }
  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
    const allRows = alldata;
    setItems(allRows);
  };
  // rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
  if (items) {
    var rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
  }
  function Active(activeid) {
    var Activebtn = (
      <td style={{ width: 100 }}>
        <button
          type="button"
          className="badge badge-success activeUser"
          onClick={(e) => handleOpen(e, activeid, 1)}
        >
          Active
        </button>
      </td>
    );
    return Activebtn;
  }

  function Blocked(blockedid) {
    var Blockedbtn = (
      <td style={{ width: 100 }}>
        <button
          type="button"
          className="badge badge-danger inactiveUser"
          onClick={(e) => handleOpen(e, blockedid, 0)}
        >
          Blocked
        </button>
      </td>
    );
    return Blockedbtn;
  }

  const deletethis = async (e, details) => {
    console.log(details);
    e.preventDefault();
    setOpen(false);
    try {
      const posttodeleteData = {
        id: details[0],
        action_type: details[1],
      };
      const resultdelete = await fetch(`${apiUrl}/admin/tradesmanaction`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(posttodeleteData),
      });
      const deleteddata = await resultdelete.json();
      const newSuccessMessage = deleteddata.message;
      setSuccessMessages([...successMessages, newSuccessMessage]);
      if (deleteddata.status !== 200) {
        throw new Error("Data not found");
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 535,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const handleSuccessMessageFadeOut = () => {
    setSuccessMessages((prevMessages) => prevMessages.slice(1));
    window.location.reload();
  };

  const newArray = [];
  const itemsValue = items;
  if (items) {
    itemsValue.map((dataItem, index) => {
      let date3 = new Date(dataItem.created_at).toLocaleDateString();
      var statusValue = "";
      if (dataItem.flag == 0) {
        statusValue = "Inactive";
      } else {
        statusValue = "Active";
      }
      const newItem = {
        Number: index + 1,
        Name: dataItem.name,
        Email: dataItem.email,
        CompanyName: dataItem.company_name,
        HomeAddress: dataItem.home_address,
        OfficeLocation: dataItem.office_location,
        Informations: dataItem.informations,
        Account_created_at: date3,
        status: statusValue,
      };
      newArray.push(newItem);
    });
    var ExcelExportData = newArray;
  }

  const getindustry = async (e) => {
    var industryId = e;
    const postindId = {
      industry_id: industryId,
    };
    const getindustryfilter = await fetch(
      `${apiUrl}/admin/providerbyindustry`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(postindId),
      }
    );
    const resultindustryfilter = await getindustryfilter.json();
    if (resultindustryfilter.status === 200) {
      const industryProvider = resultindustryfilter.data;
      setItems(industryProvider);
      localStorage.setItem("industryFilterIndustry_provider", industryId);

      rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
    }
  };

  const getcategory = async (e) => {
    const getcategoryId = e;
    const postcategoryId = {
      category_id: getcategoryId,
    };
    const getcategoryfilter = await fetch(
      `${apiUrl}/admin/providerbycategory`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(postcategoryId),
      }
    );
    const resultcategoryfilter = await getcategoryfilter.json();
    if (resultcategoryfilter.status === 200) {
      const categoryProvider = resultcategoryfilter.data;
      setItems(categoryProvider);
      localStorage.setItem("categoryFilterIndustry_provider", getcategoryId);
      rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
    }
  };
  const getsubcategory = async (e) => {
    const getsubcategoryId = e;
    const postsubcategoryId = {
      subcategory_id: getsubcategoryId,
    };
    const getsubcategoryfilter = await fetch(
      `${apiUrl}/admin/providerbysubcategory`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(postsubcategoryId),
      }
    );
    const resultsubcategoryfilter = await getsubcategoryfilter.json();
    if (resultsubcategoryfilter.status === 200) {
      const subcategoryProvider = resultsubcategoryfilter.data;
      setItems(subcategoryProvider);
      localStorage.setItem("subCategoryFilterIndustry_provider", getsubcategoryId);
      rows = items.sort((a, b) => (a.name < b.email ? -1 : 1));
    }
  };
  const clearData = async () => {
    localStorage.setItem("industryFilterIndustry_provider", "");
    localStorage.setItem("categoryFilterIndustry_provider", "");
    localStorage.setItem("subCategoryFilterIndustry_provider", "");

    getComments();
  };
  return (
    <div className="width90">
      <div className="row">
        <div className="col-sm-9">
          <h2 className="pageTitle">Providers List</h2>
        </div>
        {accessbility?.wallets.write === 1 ||
        accessbility?.wallets.write === true ? (
          <div className="mt-3 col-sm-3 text-end">
            <Link to="/admin/wallet" className="view mt-2 float-right">
              <button type="button" className="btn btn-primary">
                Wallet
              </button>
            </Link>
          </div>
        ) : null}
      </div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className="mt-4"
      />
      <div className="row">
        {/* <div className='col-sm-12'> */}
        {/* <label className="control-label col-sm-12 label mt-4" htmlFor="industrytype">*Select Industry and Category to filter SubCategory</label> */}
        <div className="form-group mt-3 col-sm-2">
          <label
            className="control-label col-sm-12 label"
            htmlFor="industrytype"
          >
            Select Industry:
          </label>
          <select
            className="form-select col-sm-12"
            onChange={(e) => getindustry(e.target.value)}
            value={localStorage.getItem("industryFilterIndustry_provider")}
          >
            <option value="">Select Industry</option>
            {industryValue
              ? industryValue.map((inditems) => {
                  return (
                    <option value={inditems.id}>
                      {inditems.industry_name}
                    </option>
                  );
                })
              : ""}
          </select>
        </div>
        <div className="form-group mt-3 col-sm-2">
          <label
            className="control-label col-sm-12 label"
            htmlFor="categorytype"
          >
            Select Category:
          </label>
          <select
            className="form-select col-sm-12"
            onChange={(e) => getcategory(e.target.value)}
            value={localStorage.getItem("categoryFilterIndustry_provider")}
          >
            <option value="">Select Category</option>
            {categoryValue
              ? categoryValue.map((catitems) => {
                  return (
                    <option value={catitems.id}>
                      {catitems.category_name}
                    </option>
                  );
                })
              : ""}
          </select>
        </div>
        <div className="form-group mt-3 col-sm-3">
          <label
            className="control-label col-sm-12 label"
            htmlFor="industrytype"
          >
            Select SubCategory:
          </label>
          <select
            className="form-select col-sm-12"
            onChange={(e) => getsubcategory(e.target.value)}
            value={localStorage.getItem("subCategoryFilterIndustry_provider")}
          >
            <option value="">Select SubCategory</option>
            {subcategoryValue
              ? subcategoryValue.map((subcatitems) => {
                  return (
                    <option value={subcatitems.id}>
                      {subcatitems.subcategory_name}
                    </option>
                  );
                })
              : ""}
          </select>
        </div>
        <div className="form-group mt-3 col-sm-3">
          <label className="control-label col-sm-12 label" htmlFor="exportData">
            Clear the filter to get all data
          </label>
          <button onClick={clearData}>Clear all filter</button>
        </div>
        <div className="mt-3 col-sm-2 text-end">
          <label className="control-label col-sm-10 label" htmlFor="exportData">
            Export Data
          </label>
          <ExportExcel excelData={ExcelExportData} fileName={"Provider"} />
        </div>
        {/* </div> */}
      </div>
      <Root sx={{ maxWidth: "100%", width: 500 }}>
        <table aria-label="custom pagination table" className="cntr">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Office Location</th>
              <th>Status</th>
              <th>Wallet</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows
              ? (rowsPerPage > 0
                  ? rows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : rows
                ).map((row) => (
                  // <tr key={row.name}>
                  <tr>
                    <td>{row.name + " " + row.lastname}</td>
                    <td style={{ width: 250 }} align="right">
                      {row.email}
                    </td>
                    <td style={{ width: 360 }} align="right">
                      {row.office_location}
                    </td>
                    {/* {row.status === '1'? Active(row.id):Blocked(row.id)} */}
                    {row.status === "1" && row.flag === "1" ? (
                      Active(row.id)
                    ) : row.flag === "0" ? (
                      <button
                        type="button"
                        className="badge badge-danger inactiveUser mt-3 mx-3"
                      >
                        Inactive
                      </button>
                    ) : (
                      Blocked(row.id)
                    )}
                    <td style={{}} align="right">
                      {accessbility?.wallets.read === 1 ||
                      accessbility?.wallets.read === true ? (
                        <Link
                          to={`/admin/wallet/transactionhistory/${row.user_id}`}
                          className="view"
                        >
                          <AiTwotoneEye />
                        </Link>
                      ) : null}
                      {accessbility?.wallets.write === 1 ||
                      accessbility?.wallets.write === true ? (
                        <Link
                          to={`/admin/wallet/editwallet/${row.user_id}`}
                          className="edit"
                        >
                          <AiTwotoneEdit />
                        </Link>
                      ) : null}
                    </td>
                    <td style={{}} align="right">
                      {accessbility?.providers.read === 1 ||
                      accessbility?.providers.read === true ? (
                        <Link
                          to={`/admin/provider/viewprovider/${row.id}`}
                          className="view"
                        >
                          <AiTwotoneEye />
                        </Link>
                      ) : null}
                      {accessbility?.providers.write === 1 ||
                      accessbility?.providers.write === true ? (
                        <Link
                          to={`/admin/provider/editprovider/${row.id}`}
                          className="edit"
                        >
                          <AiTwotoneEdit />
                        </Link>
                      ) : null}
                      {accessbility?.providers.write === 1 ||
                      accessbility?.providers.write === true ? (
                        <button
                          type="button"
                          className="delete"
                          onClick={(e) => handleOpen(e, row.id, 2)}
                        >
                          <AiTwotoneDelete />
                        </button>
                      ) : null}
                    </td>
                  </tr>
                ))
              : ""}
            {emptyRows > 0 && (
              <tr style={{ height: 41 * emptyRows }}>
                <td colSpan={6} aria-hidden />
              </tr>
            )}
          </tbody>
          <tfoot>
            <tr>
              <CustomTablePagination
                rowsPerPageOptions={[10, 25, { label: "All", value: -1 }]}
                colSpan={6}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                slotProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </tr>
          </tfoot>
        </table>
      </Root>
      {/*  */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to {messagetext} this provider?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={(e) => deletethis(e, deleteconfirm)}
            >
              OK
            </Button>
            <Button
              variant="contained"
              onClick={handleClose}
              className="cancelbtn"
            >
              Cancel
            </Button>
          </Typography>
        </Box>
      </Modal>
      {/*  */}
      {successMessages.map((message, index) => (
        <SuccessMessage
          key={index}
          message={message}
          onFadeOut={handleSuccessMessageFadeOut}
        />
      ))}
    </div>
  );
}

const grey = {
  200: "#d0d7de",
  800: "#32383f",
  900: "#24292f",
};

const Root = styled("div")(
  ({ theme }) => `
  table {
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    border: 1px solid ${theme.palette.mode === "dark" ? grey[800] : grey[200]};
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  }
  `
);

const CustomTablePagination = styled(TablePagination)`
  & .${classes.toolbar} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;

    @media (min-width: 768px) {
      flex-direction: row;
      align-items: center;
    }
  }

  & .${classes.selectLabel} {
    margin: 0;
  }

  & .${classes.displayedRows} {
    margin: 0;

    @media (min-width: 768px) {
      margin-left: auto;
    }
  }

  & .${classes.spacer} {
    display: none;
  }

  & .${classes.actions} {
    display: flex;
    gap: 0.25rem;
  }
`;

export default Provider;
